<template>
    <div class="user-profile-top-posts-wrap mb-30px">
        <div class="user-profile-top-posts-header bg-gray p-3 radius-4 d-flex align-center justify-content-between mb-20px">
            <h2 class="fs-17 d-flex justify-content-between flex-wrap flex-column">Top Posts <a href="#" class="simple-text-btn mt-5px">View all questions and answers</a></h2>

            <el-select v-model="questionFilter" placeholder="Select">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                />
            </el-select>
        </div>

        <div class="user-top-posts">
            <div v-for="list in topPosts" :key="list.id" class="top-post-list d-flex align-center" :class="list.isAnswered ? 'is_answered' : ''">
                <div class="top-post-left d-flex align-center">
                    <span class="post-answer-icon">
                        {{list.type}}
                    </span>
                    <div class="post-answer-count">
                        {{list.count}}
                    </div>
                </div>
                <div class="top-post-content">
                    <router-link class="d-inline-block transition-3s" :to="{name: 'question-single', params: {question_id: list.id}}">
                        {{list.title}}
                    </router-link>
                    <span class="post-date d-block w-full">{{list.date}}</span>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
export default {
    name: 'TopPosts',
    data() {
        return {
            questionFilter: 'all',
            options: [
                {
                    value: 'all',
                    label: 'All'
                },
                {
                    value: 'questions',
                    label: 'Questions'
                },
                {
                    value: 'answers',
                    label: 'Answers'
                },
                {
                    value: 'articles',
                    label: 'Articles'
                }
            ],
            topPosts: [
                {
                    id: 1,
                    isAnswered: true,
                    count: '3',
                    title: "Blur rectangle-shaped div edges?",
                    date: "Jan 7, 2019",
                    type: 'A'
                },
                {
                    id: 2,
                    isAnswered: true,
                    count: '4',
                    title: "Dropdown menu won't appear in elementor Wordpress",
                    date: "Aug 5, 2019",
                    type: 'A'
                },
                {
                    id: 3,
                    isAnswered: true,
                    count: '4',
                    title: "CSS dropdown menu disappears when using bootstrap carousel",
                    date: "Jun 3, 2020",
                    type: 'A'
                },
                {
                    id: 4,
                    isAnswered: false,
                    count: '7',
                    title: "Image resizing distorted in Safari on iOS",
                    date: "Jun 10, 2020",
                    type: 'A'
                },
                {
                    id: 5,
                    isAnswered: false,
                    count: '10',
                    title: "On hover flip the semi-circle",
                    date: "Sep 2, 2019",
                    type: 'Q'
                }
            ]
        }
    }
}
</script>